import { defineAsyncComponent } from 'vue'
export default {
  dashboard: defineAsyncComponent(() => import("C:/Projects/RLA/RLA_FRONT/layouts/dashboard.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("C:/Projects/RLA/RLA_FRONT/layouts/login.vue").then(m => m.default || m)),
  main: defineAsyncComponent(() => import("C:/Projects/RLA/RLA_FRONT/layouts/main.vue").then(m => m.default || m))
}